module.exports = __webpack_public_path__ + "img/pcdtbblz.44edb7bb.png";